import classNames from 'classnames'
import s from './index.module.css'
import { Baskets } from '../Baskets'
import { useState } from 'react'
import { initializeBaskets } from '../../utils/initializeBaskets'

export const CorrectAnswers = ({correctAnswer, baskets, answerOptions}) => {
    const [basketsCorrect, setBasketsCorrect] = useState(
        initializeBaskets({
            baskets: baskets,
            hasAnswers: true,
            answers: correctAnswer, // передаем корректные ответы, чтобы их правильно отобразить
            answerOptions: answerOptions
        })
    );

    return(
        <>
            <span className={classNames(s.capsuleLeft)}>Правильные ответы</span>

            <Baskets
                baskets={basketsCorrect}
                isInteractive = {false}
            />
        </>
    )
}